
import React from 'react';
import { X } from 'lucide-react';

interface TermsModalProps {
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Terms of Service</h2>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <div>
            <h3 className="text-lg font-semibold mb-3">Acceptance of Terms</h3>
            <p className="text-gray-600">
              By accessing and using Discount Pro's services, you accept and agree to be bound by the 
              terms and provision of this agreement.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Service Description</h3>
            <p className="text-gray-600 mb-4">
              Discount Pro provides information about deals, discounts, and coupons from various retailers. 
              Our services include:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-1">
              <li>Email newsletters with deal information</li>
              <li>Website access to current deals</li>
              <li>SMS notifications (if opted in)</li>
              <li>Customer support</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">User Responsibilities</h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-1">
              <li>Provide accurate information when signing up</li>
              <li>Use the service for personal, non-commercial purposes</li>
              <li>Respect intellectual property rights</li>
              <li>Not attempt to harm or disrupt the service</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Deal Information</h3>
            <p className="text-gray-600">
              While we strive to provide accurate and up-to-date deal information, we cannot guarantee 
              the availability, accuracy, or terms of any deal. Deals are subject to change without notice.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Limitation of Liability</h3>
            <p className="text-gray-600">
              Discount Pro is not liable for any direct, indirect, incidental, or consequential damages 
              arising from your use of our services or any deals obtained through our platform.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Termination</h3>
            <p className="text-gray-600">
              You may terminate your account at any time by unsubscribing from our emails or contacting 
              us. We reserve the right to terminate accounts that violate these terms.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Changes to Terms</h3>
            <p className="text-gray-600">
              We may update these terms from time to time. We will notify you of any significant changes 
              via email or through our website.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Contact Information</h3>
            <p className="text-gray-600">
              For questions about these Terms of Service, please contact us at help@discountpro.org.
            </p>
          </div>

          <div className="text-sm text-gray-500">
            Last updated: January 2025
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
